module.exports = __webpack_public_path__ + "static/media/bg_girl_talking.39476007.png";